'use strict';
(() => {
  // Only these public product choices may become copy, links or customer tags.
  const interests = Object.freeze({
    water: {
      title: 'Bacteriostatic Water for Injection',
      path: '/pages/bacteriostatic-water-for-injection'
    },
    sterile: {
      title: 'Sterile Water for Injection',
      path: '/pages/sterile-water-for-injection'
    },
    bacteriostaticsaline: {
      title: 'Bacteriostatic 0.9% Sodium Chloride Injection',
      path: '/pages/bacteriostatic-sodium-chloride-injection'
    },
    saline: {
      title: '0.9% Sodium Chloride Injection — Preservative-Free',
      path: '/pages/sodium-chloride-injection-preservative-free'
    },
    syringes: {
      title: 'Insulin Syringes',
      path: '/pages/insulin-syringes'
    },
    needles: {
      title: 'General-Purpose Syringes',
      path: '/pages/hypodermic-needles'
    }
  });
  const presentations = Object.freeze({
    'hospira-sw-10ml': {
      interest: 'sterile',
      title: 'Hospira · 10 mL single-dose vial'
    }
  });
  const storageKey = 'bw-signup-context-v1';
  const storageLifetime = 30 * 60 * 1000;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  function resolveContext(interest, presentation) {
    const key = typeof interest === 'string' ? interest.toLowerCase() : '';
    if (!own(interests, key)) return null;
    const selected = typeof presentation === 'string' &&
      own(presentations, presentation) && presentations[presentation].interest === key;
    return { interest: key, presentation: selected ? presentation : '' };
  }

  function readPendingContext() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (!saved || !Number.isFinite(saved.time) || saved.time > Date.now() ||
          Date.now() - saved.time > storageLifetime || saved.path !== location.pathname) return null;
      return resolveContext(saved.interest, saved.presentation);
    } catch (_) {
      return null;
    }
  }

  function clearPendingContext() {
    try { sessionStorage.removeItem(storageKey); } catch (_) { /* Storage is optional. */ }
  }

  function setup(scope = document) {
    scope.querySelectorAll('[data-bw-signup]').forEach((wrapper) => {
      if (wrapper.dataset.bwSignupReady) return;
      wrapper.dataset.bwSignupReady = 'true';
      const form = wrapper.querySelector('form');
      const tags = wrapper.querySelector('[data-bw-signup-tags]');
      if (!form || !tags) return;

      const params = new URLSearchParams(location.search);
      const hasQueryContext = params.has('interest') || params.has('presentation');
      const response = wrapper.querySelector('[data-bw-signup-response]');
      let context = resolveContext(params.get('interest'), params.get('presentation'));
      // Shopify can return without the original query. Restore only after a
      // native form response, never merely when someone revisits general signup.
      if (!hasQueryContext && response) context = readPendingContext();
      const contextPanel = wrapper.querySelector('[data-bw-signup-context]');
      const detail = wrapper.querySelector('[data-bw-signup-detail]');
      const note = wrapper.querySelector('[data-bw-signup-context-note]');
      const returnLink = wrapper.querySelector('[data-bw-signup-return]');

      if (context) {
        const product = interests[context.interest];
        wrapper.querySelector('[data-bw-signup-title]').textContent = product.title;
        contextPanel.hidden = false;
        const submittedTags = new Set(tags.value.split(',').map((tag) => tag.trim()).filter(Boolean));
        submittedTags.add('bw-interest-' + context.interest);
        if (context.presentation) {
          detail.textContent = presentations[context.presentation].title;
          detail.hidden = false;
          submittedTags.add('bw-presentation-' + context.presentation);
        } else if (params.has('presentation')) {
          note.textContent = 'This presentation is not listed. You can still receive updates about this product.';
          note.hidden = false;
        }
        // Append to this form's base tags; do not claim to merge remote customer
        // records. Shopify's handling of repeat subscribers needs platform testing.
        tags.value = Array.from(submittedTags).join(',');
        returnLink.href = product.path + (context.presentation ? '?presentation=' + context.presentation : '');
        returnLink.querySelector('[data-bw-signup-return-label]').textContent = 'Back to product details';
      } else if (hasQueryContext) {
        note.textContent = 'This product selection is not listed. You can still receive general service updates.';
        note.hidden = false;
      }

      if (!response) clearPendingContext();
      form.addEventListener('submit', () => {
        if (!context) {
          clearPendingContext();
          return;
        }
        // Only the temporary product choice is saved; no email or consent state is stored.
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            interest: context.interest,
            presentation: context.presentation,
            path: location.pathname,
            time: Date.now()
          }));
        } catch (_) { /* The native customer form works without browser storage. */ }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
